import React from 'react';

import {FineUploaderBasic} from 'fine-uploader/lib/core';
import styled from 'styled-components';

import FineUploaderFileList from 'app/general/widgets/FineUploaderFileList';

interface Props {
  uploaderRef: React.MutableRefObject<FineUploaderBasic>;
  submittedImages: Array<number>;
  onCancelImage: (id: number) => void;
}

export function ImageAttachmentsList({
  uploaderRef,
  submittedImages,
  onCancelImage,
}: Props) {
  if (submittedImages.length === 0) {
    return null;
  }
  return (
    <StyledUploadsContainer className="p-2">
      <FineUploaderFileList
        uploader={uploaderRef.current}
        files={submittedImages}
        onCancelFile={onCancelImage}
        cancelButton={<span className="d-none" />}
      />
    </StyledUploadsContainer>
  );
}

const StyledUploadsContainer = styled.div`
  max-height: 300px;
  overflow-y: auto;
  contain: inline-size;

  .d-flex:has(.react-fine-uploader-filesize) {
    display: none !important;
  }
  .progress-bar {
    color: transparent;
  }

  .progress {
    height: 0.2rem;
  }
`;
